// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"025d72e3","154":"e5f23a0c"}[chunkId] + ".chunk.css";
};